import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import Form from "react-bootstrap/Form";
import TelegramIcon from "../assets/svg/TelegramIcon";
import WhatsappIcon from "../assets/svg/WhatsappIcon";
import EyeIcon from "../assets/svg/EyeIcon";
import { useNavigate } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import logo from "../assets/svg/logo_new.png";
import SportsIcon from "../assets/images/games-icon/Exchange.svg";
import BotHeadIcon1 from "../assets/images/games-icon/In-play.svg";
import CasinoIcon from "../assets/images/games-icon/Casino.svg";
import BotHeadIcon2 from "../assets/images/games-icon/Cricket.svg";
import BotHeadIcon3 from "../assets/images/games-icon/Soccer.svg";
import Tennis from "../assets/images/games-icon/Tennis.svg";
import HorseRacing from "../assets/images/games-icon/HorseRacing.svg";
import XPG from "../assets/images/games-icon/XG.svg";
import livetv from "../assets/images/games-icon/livetv-icon.png";
import BotHeadIcon4 from "../assets/images/games-icon/Aviator.png";
import BotHeadIcon5 from "../assets/images/games-icon/dragon-tiger1.png";
import BotHeadIcon6 from "../assets/images/games-icon/Teen-patti.png";
import BotHeadIcon7 from "../assets/images/games-icon/roulette.png";
import SportsIcon1 from "../assets/images/games-icon/Exchange.png";
import HomeIcon1 from "../assets/images/games-icon/home-icon1.png";
import EzugiIcon from "../assets/images/games-icon/Ezugi.png";
import SlotsnIcon from "../assets/images/games-icon/slots.png";
import CashierIcon1 from "../assets/images/games-icon/cashier.png";
import { useSelector } from "react-redux";
import BotHeadIcon10 from "../assets/images/games-icon/Tennis.png";
import BotHeadIcon11 from "../assets/images/games-icon/slots.png";
import login from "../assets/images/icons/header/user.png";
import signup from "../assets/images/icons/header/user.png";
// import BotHeadIcon4 from "../assets/images/games-icon/Aviator.png";

import LockImg from "../assets/images/icons/header/padlock.png";

import { useDispatch } from "react-redux";
import { loginUser } from "../redux/auth/actions";
// import DeviceDetector from "device-detector-js";
import hide from "../assets/svg/hide.png";

const Header = () => {
  //test
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { appDetails } = useSelector((state) => state.app);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  // const deviceDetector = new DeviceDetector();
  // const userAgent = window.navigator.userAgent;
  // const device = deviceDetector.parse(userAgent);

  const validateData = () => {
    const { username, password } = formData;
    const newErrors = {};
    if (!username || username === "") {
      newErrors.username = "Username cannot be empty";
    }
    if (!password || password === "") {
      newErrors.password = "Password cannot be empty";
    }
    return newErrors;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const errorData = validateData();
    if (Object.keys(errorData).length > 0) {
      setErrors(errorData);
    } else {
      let loginData = { ...formData };
      // loginData.device_info = device.device.type;
      // loginData.browser_info = device.client.name;
      // loginData.rountname = "user";
      dispatch(loginUser(loginData));
    }
  };
  const handleChange = (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    let tempFormData = { ...formData, [fieldName]: fieldValue };
    setFormData(tempFormData);
  };

  return (
    <>
      <header className="header beforeheader">
        <div className="top_head">
          <Container fluid>
            <Row>
              <Col xs={12}>
                <div className="d-flex justify-content-between align-items-start">
                  <div className="logo">
                    <a href="/">
                      <img src={appDetails?.LOGO_URL} alt="Logo" />
                    </a>
                  </div>
                  <div className="middle-part d-none">
                    <Navbar expand="lg">
                      <Container>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                          <Nav className="me-auto">
                            <Nav.Link href="/">
                              {/* <HomeIcon /> */}
                              <img src={HomeIcon1} />
                              Home
                            </Nav.Link>
                            <Nav.Link
                              href="/sportsbook"
                              className="exchange-nav"
                            >
                              <div>
                                {/* <SportsIcon /> */}
                                <img src={SportsIcon1} />
                              </div>
                              Exchange
                            </Nav.Link>

                            <Nav.Link href="/sign-in">
                              {/* <GamesIcon />  */}
                              <img src={EzugiIcon} />
                              Ezugi
                            </Nav.Link>
                            <Nav.Link href="/sign-in">
                              {/* <GamesIcon />  */}
                              <img src={EzugiIcon} />
                              Evolution
                            </Nav.Link>
                            <Nav.Link href="/sign-in">
                              {/* <GamesIcon />  */}
                              <img src={SlotsnIcon} />
                              Slots
                            </Nav.Link>
                            {/* <Nav.Link href={CasinoProviders["worldcasino"]?.href}>
                      <GamesIcon />
                      World Casino
                    </Nav.Link> */}
                            {/* <Nav.Link href="/games-all">
                        <GamesIcon /> Casino
                      </Nav.Link> */}
                            <Nav.Link href="/sign-in">
                              {/* <CashierIcon /> */}
                              <img src={CashierIcon1} />
                              Cashier
                            </Nav.Link>
                          </Nav>
                        </Navbar.Collapse>
                      </Container>
                    </Navbar>
                  </div>
                  <div className="headerRight ">
                    <ul className="social d-none">
                      <li>
                        <a
                          href={
                            appDetails?.TELEGRAM != ""
                              ? appDetails?.TELEGRAM
                              : "#"
                          }
                          target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                        >
                          <TelegramIcon />
                        </a>
                      </li>
                    </ul>
                    <div className="login-signup-btn">
                      <div className="d-md-flex d-none DesktopLogin">
                        <Form>
                          <Form.Group className="" controlId="formBasicName">
                            <Form.Control
                              type="text"
                              placeholder="Enter Username*"
                              name="username"
                              onChange={handleChange}
                              isInvalid={!!errors.username}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors?.username}
                            </Form.Control.Feedback>
                          </Form.Group>
                          <Form.Group
                            className=" position-relative"
                            controlId="formBasicPassword"
                          >
                            <Form.Control
                              type={showPassword ? "text" : "password"}
                              placeholder="Password*"
                              name="password"
                              onChange={handleChange}
                              isInvalid={!!errors.password}
                            />
                            <span
                              className="icon"
                              onClick={() => setShowPassword((s) => !s)}
                            >
                              {showPassword ? (
                                <img src={hide} alt="" />
                              ) : (
                                <EyeIcon />
                              )}
                            </span>
                            <Form.Control.Feedback type="invalid">
                              {errors?.password}
                            </Form.Control.Feedback>
                          </Form.Group>
                          <div className="d-flex justify-content-end ">
                            <a className="form-link" href="/forgot-password">
                              Forgot your password ?
                            </a>
                          </div>
                          <Button
                            variant="primary"
                            type="submit"
                            onClick={handleSubmit}
                          >
                            Log In <img src={LockImg} alt="lock" />
                          </Button>
                        </Form>
                      </div>
                      <Button
                        variant="primary"
                        onClick={() => {
                          navigate("/sign-in");
                        }}
                        className="button-primary btn_signin d-flex d-md-none"
                      >
                        <img
                          src={login}
                          alt="login"
                          className="d-block d-md-none"
                        />
                        Login
                      </Button>
                      <Button
                        variant="primary"
                        onClick={() => {
                          navigate("/mobile-number");
                        }}
                        className="button-primary btn_signup"
                      >
                        <img
                          src={signup}
                          alt="login"
                          className="d-block d-md-none"
                        />
                        Register
                      </Button>
                      <Button
                        variant="primary"
                        onClick={() => {
                          navigate("/sign-in");
                        }}
                        className="button-primary btn_signin d-md-none d-flex"
                      >
                        <span>0</span>
                        Betslip
                      </Button>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* <Offcanvas
        className={"steps-canvas"}
        show={show}
        onHide={handleClose}
        placement={"end"}
      >
        <Offcanvas.Header closeButton="closeButton" closeVariant="white">
          <Offcanvas.Title>
            <span className="top-heading">Sign in now!</span>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form-steps">
            <h2 className="h2">Hello Again!</h2>
            <p>
              Welcome back, you've
              <br />
              been missed!
            </p>
            <Form>
              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Control type="text" placeholder="Enter Username*" />
              </Form.Group>
              <Form.Group
                className="mb-3 position-relative"
                controlId="formBasicPassword"
              >
                <Form.Control type="password" placeholder="Password*" />
                <span className="icon">
                  <EyeIcon />
                </span>
              </Form.Group>
              <div className="d-flex justify-content-end mb-3">
                <a className="form-link" href="#">
                  Password Recovery
                </a>
              </div>
              <Button variant="primary" type="submit">
                Sign in
              </Button>
            </Form>
            <div className="sign-up mt-4">
              Not a member?
              <br />
              <a href="register">Sign Up Now</a>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas> */}
      </header>
      <div className="bottom_head">
        <Container fluid>
          <Row>
            <Col xs={12} className="">
              <ul>
                <li>
                  <a href="/mobile-number">
                    <img src={SportsIcon} alt="bottom head link icon" />
                    <span>Inplay</span>
                  </a>
                </li>

                <li>
                  <a
                    onClick={() => {
                      navigate("/sports", { state: { selectedTab: "3" } });
                    }}
                  >
                    <img src={BotHeadIcon2} alt="bottom head link icon" />
                    <span>Football</span>
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      navigate("/sports", { state: { selectedTab: "3" } });
                    }}
                  >
                    <img src={BotHeadIcon3} alt="bottom head link icon" />
                    <span>Tennis</span>
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      navigate("/sports", { state: { selectedTab: "3" } });
                    }}
                  >
                    <img src={BotHeadIcon10} alt="bottom head link icon" />
                    <span>Basketball</span>
                  </a>
                </li>

                <li>
                  <a href="/Slots">
                    <img src={BotHeadIcon11} alt="bottom head link icon" />
                    <span>Slots</span>
                  </a>
                </li>
                <li>
                  <a href="/mobile-number">
                    <img src={CasinoIcon} alt="bottom head link icon" />
                    <span>Live Casino</span>
                  </a>
                </li>
                {/* <li>
                  <a href="/casino/qt-aviator">
                    <img src={BotHeadIcon4} alt="bottom head link icon" />
                    <span>Aviator</span>
                  </a>
                </li> */}
                {/* <li>
              <a href="/mobile-number">
                <img src={BotHeadIcon2} alt="bottom head link icon" />
                <span>Cricket</span>
              </a>
            </li>
            <li>
              <a href="/mobile-number">
                <img src={BotHeadIcon3} alt="bottom head link icon" />
                <span>Soccer</span>
              </a>
            </li>
            <li>
              <a href="/mobile-number">
                <img src={Tennis} alt="bottom head link icon" />
                <span>Tennis</span>
              </a>
            </li> */}
                {/* <li>
              <a href="/mobile-number">
                <img src={HorseRacing} alt="bottom head link icon" />
                <span>Horse Racing</span>
              </a>
            </li>
            <li>
              <a href="/mobile-number">
                <img src={XPG} alt="bottom head link icon" />
                <span>XPG</span>
              </a>
            </li>
            <li>
              <a href="/mobile-number">
                <img src={livetv} alt="bottom head link icon" />
                <span>Live TV</span>
              </a>
            </li> */}
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Header;
